import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { VehicleStatusEnum } from '../enums/vehicle-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function vehicleStatusToColor(status: VehicleStatusEnum): string {
	switch (status) {
		case VehicleStatusEnum.IN_PARK:
			return RecordColorEnum.GREEN;

		case VehicleStatusEnum.OUT_OF_SERVICE:
			return RecordColorEnum.RED;

		case VehicleStatusEnum.HARD_HOLD:
			return RecordColorEnum.ORANGE;

		case VehicleStatusEnum.RESERVED:
			return RecordColorEnum.PURPLE;
		case VehicleStatusEnum.RESERVED_MAINTENANCE:
			return RecordColorEnum.TEAL;

		case VehicleStatusEnum.RENTED:
			return RecordColorEnum.BLUE;

		case VehicleStatusEnum.IN_MAINTENANCE:
			return RecordColorEnum.AMBER;

		case VehicleStatusEnum.SOLD:
			return RecordColorEnum.TEAL;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
